/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs */

const en_shortcut_keys_desc_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move the Event position down 1 line`)
};

const fr_shortcut_keys_desc_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer la position de l'evenement d'une ligne vers le bas`)
};

const de_shortcut_keys_desc_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschieben Sie die Ereignisposition um eine Zeile nach unten.`)
};

const it_shortcut_keys_desc_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta la posizione dell'evento di 1 riga verso il basso`)
};

const ru_shortcut_keys_desc_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместите позицию события на одну строку вниз.`)
};

const es_shortcut_keys_desc_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mueva la posición del evento hacia abajo 1 línea`)
};

const zh_cn2_shortcut_keys_desc_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将事件位置向下移动一行`)
};

const ja_shortcut_keys_desc_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの位置を1行下に移動します`)
};

const hi_shortcut_keys_desc_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट की स्थिति को 1 पंक्ति नीचे ले जाएं`)
};

const pt_pt2_shortcut_keys_desc_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desloque a posição do evento uma linha para baixo.`)
};

/**
* | output |
* | --- |
* | "Move the Event position down 1 line" |
*
* @param {Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_move_down_one_line = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_cc_move_down_one_line(inputs)
	if (locale === "de") return de_shortcut_keys_desc_cc_move_down_one_line(inputs)
	if (locale === "it") return it_shortcut_keys_desc_cc_move_down_one_line(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_cc_move_down_one_line(inputs)
	if (locale === "es") return es_shortcut_keys_desc_cc_move_down_one_line(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_cc_move_down_one_line(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_cc_move_down_one_line(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_cc_move_down_one_line(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_cc_move_down_one_line(inputs)
	return en_shortcut_keys_desc_cc_move_down_one_line(inputs)
});